export default {
    view: "Veja mais"
}